import GameParameterInterface from '@/models/game/parameters/interface'

export interface WaniPanicLotteryParameter {
  prize: WaniPanicGamePrize
  generalValue: string
}

interface WaniPanicGamePrize {
  prizeImage: string,
}

export default class WaniPanicParameter implements GameParameterInterface {
  constructor(private parameter: WaniPanicLotteryParameter) { }

  createSetOption(): WaniPanicLotteryParameter {
    return {
      prize: this.parameter.prize,
      generalValue: this.parameter.generalValue,
    }
  }

  get guideUrl(): string {
    return ''
  }
}
